import React from 'react';

// Падение одной страницы не должно давать белый экран всего сайта: ловим ошибку рендера
// вкладки и показываем её текст (по нему чиним) + кнопку перезагрузки. Стоит ВНУТРИ стабильного
// div вкладки (TabsKeepAlive) — ключи и монтирование страниц не меняет.
// Новый элемент страницы (переход по ссылке, новые props) — пробуем отрисовать заново.
class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[PageErrorBoundary]', this.props.path, error, info && info.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.children !== this.props.children) this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div style={{ padding: 24, fontFamily: 'inherit' }}>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>На странице произошла ошибка</div>
        <div style={{ fontSize: 13, color: 'var(--color-neutral-600)', marginBottom: 12, whiteSpace: 'pre-wrap' }}>
          {String((error && error.message) || error)}
        </div>
        <button type="button" onClick={() => window.location.reload()}
          style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid var(--color-neutral-300)', background: 'var(--surface-card)', cursor: 'pointer' }}>
          Перезагрузить
        </button>
      </div>
    );
  }
}

export default PageErrorBoundary;
